<template>
  <div
    class="gift-wrap-item grid"
    :class="{ [$class('updating')]: state === 'updating' }"
  >
    <responsive-image
      block-class="line-item"
      :image="product.featuredImage"
      :lazy-load="false"
      min-max="113-145"
      ratio="3:4"
      sizes="113px"
    />

    <div class="gift-wrap-item__body">
      <p
        class="gift-wrap-item__title text-heading-3xs text-heading-xs-desktop"
        v-text="product.title"
      />

      <p
        class="gift-wrap-item__description text-body-xs text-body-s-desktop"
        v-text="product.description"
      />

      <div class="gift-wrap-item__checkbox checkbox">
        <input
          id="gift-wrap-item"
          class="checkbox__input"
          :checked="cartGiftWrap"
          :disabled="state !== 'ready'"
          name="gift-wrap-item"
          type="checkbox"
          value="gift-wrapping"
          @change="onChange"
        >

        <label
          class="gift-wrap-item__checkbox-label checkbox__label text-body-xs"
          for="gift-wrap-item"
          v-text="checkboxLabel"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: gift-wrap-item (gift-wrap-item)
 * -----------------------------------------------------------------------------
 * Gift wrap item to be used in cart page.
 *
 * @param {Object} product - Gift wrapping product object.
 *
 */
import { mapActions, mapState } from 'vuex'

import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'GiftWrapItem',

  components: {
    ResponsiveImage,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      state: 'loading',
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
      cartStatus: (state) => state.cart.status,
    }),

    /**
     * Returns gift wrap line item if in cart.
     * @return {Object|Boolean}
     */
    cartGiftWrap() {
      return this.cart.items.find((item) => {
        return item.id === this.product?.variants[0]?.id
      }) || false
    },

    /**
     * Decide which text will be shown on free shipping progress bar.
     * @returns {string}
     */
    checkboxLabel() {
      return this.cartGiftWrap
        ? this.$string('cart.gift_wrapping.success')
        : this.$string(
          'cart.gift_wrapping.add',
          { replace: { value: this.$formatMoney(this.product?.price?.amount) } },
        )
    },
  },

  watch: {

    /**
     * Watch cart status items to see if item is being updated.
     */
    'cartStatus.items'() {
      if (this.cartStatus.items.includes(this.product?.id)) {
        this.state = 'updating'
        return
      }

      this.state = 'ready'
    },
  },

  mounted() {
    this.state = 'ready'
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      addItem: 'cart/addItem',
      removeItem: 'cart/updateItem',
    }),

    /**
     * Watch change to update cart.
     */
    onChange() {
      if (this.cartGiftWrap) {
        this.removeItem(this.cartGiftWrap.key)
        return
      }

      this.addItem([
        {
          id: this.product?.variants[0]?.id,
          quantity: 1,
        },
      ])
    },
  },
}
</script>

<style lang="scss">
@import './gift-wrap-item';
</style>
